import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    top: -7,
    height: 6,
    padding: 1,
    background: '#fff'
  },
  progressContainer: {
    height: 4,
    border: '1px solid #f5f5f5',
    boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, .1)'
  },
  progress: {
    height: '100%',
    backgroundColor: '#72ccb3'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/File/ProgressBar/styles.js